<template>
  <div>
    <v-card elevation="0" class="px-7">
      <v-row dense align="center" justify="space-between">
        <v-col cols="12" sm="6">
          <h1 class="fs-16 primary--text font-weight-bold">
            Request
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-breadcrumbs class="app-breadcrumbs py-3" :items="breadcrumbs" />
        </v-col>
      </v-row>
    </v-card>

    <v-container class="px-7" fluid>
      <v-row no-gutters align="center" justify="space-between" class="mb-3">
        <v-col cols="12" sm="6">
          <h1 class="fs-20 font-weight-bold bluedarken--text mt-2">
            Request List
          </h1>
        </v-col>
        <v-col cols="12" sm="auto">
          <dashboard-filter @reset="resetFilter()" />
          <v-btn color="primary" icon large @click="fetchData()">
            <v-icon color="bluedarken" class="icon-bold icon-large mt-2" large>
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="px-3 mb-3">
        <v-expansion-panels flat class="filterby-info" v-model="panelFilter">
          <v-expansion-panel>
            <v-expansion-panel-header
              class="primary--text fs-13 px-0 pt-0 pb-1 secondary"
              height="100px"
            >
              Filter By Information
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey--text secondary">
              <table width="auto" v-if="filterInfo.length > 0">
                <tr
                  v-for="(filter, index) in filterInfo"
                  :key="'filter' + index"
                  class="text-left mb-0 text-capitalize fs-13"
                >
                  <!-- name filter -->
                  <td class="font-weight-bold">
                    <span v-if="filter.name === 'type_of_activity'">
                      Activity
                    </span>
                    <span v-if="filter.name !== 'status'">
                      {{ filter.name.split('_').join(' ') }}
                    </span>
                    <span v-else>
                      {{ filter.name }}
                    </span>
                  </td>
                  <!-- value filter -->
                  <td class="pl-3">
                    <span v-if="filter.name === 'status'">
                      {{
                        filter.value
                          .join(', ')
                          .split('_')
                          .join(' ')
                      }}
                    </span>
                    <span v-else-if="filter.name === 'house'">
                      {{ filter.value.name }}
                    </span>
                    <span v-else-if="filter.name === 'start_year'">
                      {{ formatYear(filter.value) }}
                    </span>
                    <span v-else>
                      {{ filter.value }}
                    </span>
                  </td>
                </tr>
              </table>

              <span v-else class="fs-13">
                No filter exists.
              </span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>

      <v-card :loading="loading" class="elevation-card rounded-12 mb-5">
        <v-card-title>
          <v-icon color="primary2" class="mr-2">
            mdi-web
          </v-icon>
          <span class="fs-14 font-weight-bold primary2--text">
            Request
          </span>
          <v-spacer />
          <select-column-filter
            v-model="columnActive"
            :headers="headers"
            customClass="ma-0"
          />
          <v-btn
            v-if="isLoggedInAsFOMSSHCP"
            to="/sshcp/requests/create"
            depressed
            dark
            color="menuActive"
            class="btn-medium ml-4"
          >
            Add New Request
          </v-btn>
          <v-btn
            depressed
            dark
            color="menuActive"
            class="btn-medium ml-4"
            @click="download"
            :loading="downloading"
          >
            Download
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-simple-table
            fixed-header
            class="table-taxonomy nav-table sshcf-table"
          >
            <template v-slot:default>
              <VuePerfectScrollbar
                class="drawer-menu--scroll"
                :settings="scrollSettings"
              >
                <thead>
                  <tr>
                    <template v-for="(header, index) in headers">
                      <th
                        v-if="isHeaderSelected(header)"
                        :key="header.text"
                        class="white--text"
                        :class="{
                          [`text-${header.align}`]: true,
                          [header.customClass]: !!header.customClass
                        }"
                      >
                        <span>{{ header.text }}</span>
                        <filter-column
                          v-if="header.value !== 'action'"
                          :indexItem="index"
                          :field="header.value"
                          :listFilter="getFiltered(header.value, index)"
                          :columnType="header.columnType || false"
                          :isCode="header.isCode"
                          @sortAsc="getNestedSort"
                          @searchColumn="searchCln"
                          @filterItem="searchCln"
                        />
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in filteredItems"
                    :key="item.name"
                    class="hoverable-tr"
                  >
                    <td
                      v-if="isColumnSelected('unique_code')"
                      @click="onRowClicked(item)"
                      class="sticky-body1"
                    >
                      <router-link
                        :to="`/sshcp/request/${item.id}`"
                        class="bluedarken--text text-link"
                      >
                        {{ item.unique_code }}
                      </router-link>
                    </td>
                    <td
                      v-if="isColumnSelected('po_number')"
                      @click="onRowClicked(item)"
                    >
                      {{ item.po_number }}
                    </td>
                    <td
                      v-if="isColumnSelected('io_number')"
                      @click="onRowClicked(item)"
                    >
                      {{ item.io_number }}
                    </td>
                    <td
                      v-if="isColumnSelected('house')"
                      @click="onRowClicked(item)"
                    >
                      {{ item.house }}
                    </td>
                    <td
                      v-if="isColumnSelected('region')"
                      @click="onRowClicked(item)"
                    >
                      {{ item.region }}
                    </td>
                    <td
                      v-if="isColumnSelected('district')"
                      @click="onRowClicked(item)"
                    >
                      {{ item.district }}
                    </td>
                    <td
                      v-if="isColumnSelected('type_of_activity')"
                      @click="onRowClicked(item)"
                    >
                      {{ item.type_of_activity }}
                    </td>
                    <td
                      v-if="isColumnSelected('events')"
                      @click="onRowClicked(item)"
                    >
                      {{ item.events }}
                    </td>
                    <td
                      v-if="isColumnSelected('total_budget')"
                      @click="onRowClicked(item)"
                      class="text-right"
                    >
                      {{ idr(item.total_budget) }}
                    </td>
                    <td
                      v-if="isColumnSelected('cost_per_pax')"
                      @click="onRowClicked(item)"
                      class="text-right"
                    >
                      {{ idr(item.cost_per_pax) }}
                    </td>
                    <td
                      v-if="isColumnSelected('current_approval')"
                      @click="onRowClicked(item)"
                    >
                      <v-menu
                        open-on-hover
                        top
                        offset-y
                        v-if="item.pending_approval.length > 1"
                      >
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            {{ item.pending_approval.length }} Approvers
                          </div>
                        </template>
                        <v-card
                          flat
                          outlined
                          :elevation="0"
                          style="boder-radius: 25px !important"
                        >
                          <v-card-title
                            class="blue-grey lighten-5 fs-12 px-2 py-0 grey--text text--darken-1"
                          >
                            <span class="font-weight-bold">Approvers</span>
                          </v-card-title>
                          <v-card-text
                            class="fs-12 grey--text text--darken-1 pa-2"
                          >
                            <v-flex
                              xs12
                              v-for="(name, idx) in item.pending_approval"
                              :key="'name' + idx"
                            >
                              <span class="text-capitalize">
                                - {{ name.name }}
                              </span>
                            </v-flex>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                      <div
                        v-else-if="item.pending_approval.length === 1"
                        class="text-capitalize"
                      >
                        {{ item.pending_approval[0].name.toLowerCase() }}
                      </div>
                    </td>
                    <td
                      v-if="isColumnSelected('local_status')"
                      @click="onRowClicked(item)"
                      class="text-uppercase"
                    >
                      {{ item.local_status }}
                    </td>
                    <td v-if="isColumnSelected('action')">
                      <v-btn
                        text
                        color="primary"
                        class="text-capitalize font-weight-bold"
                        :to="`/sshcp/request/detail/${item.id}`"
                      >
                        <v-img
                          src="@/assets/images/icon-doc.png"
                          width="16"
                          height="16"
                          class="mr-2"
                        />
                        Details
                      </v-btn>
                      <preval-number
                        v-if="item.afterBRightButton"
                        :item="item"
                        @fetchData="fetchData"
                      />
                      <v-btn
                        text
                        color="primary"
                        class="text-capitalize font-weight-bold"
                        :to="`/sshcp/requests/history/${item.id}`"
                      >
                        History
                      </v-btn>
                    </td>
                  </tr>
                  <tr class="bgTotal" v-if="filteredItems.length > 0">
                    <td
                      v-if="isColumnSelected('unique_code')"
                      class="sticky-body1 font-weight-bold sticky-amount"
                      style="z-index: 3 !important;"
                    >
                      TOTAL
                    </td>
                    <td
                      v-if="isColumnSelected('po_number')"
                      class="border-r-0 text-right sticky-amount"
                      style="z-index: 2 !important"
                    ></td>
                    <td
                      v-if="isColumnSelected('io_number')"
                      class="text-right border-x-0  sticky-amount"
                      style="z-index: 2 !important"
                    ></td>
                    <td
                      v-if="isColumnSelected('house')"
                      class="border-x-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('region')"
                      class="border-x-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('district')"
                      class="border-x-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('type_of_activity')"
                      class="border-x-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('events')"
                      class="border-x-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('total_budget')"
                      class="sticky-amount font-weight-bold text-right"
                    >
                      {{ totalAmountFor('total_budget') }}
                    </td>
                    <td
                      v-if="isColumnSelected('cost_per_pax')"
                      class="border-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('current_approval')"
                      class="border-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('local_status')"
                      class="border-x-0 sticky-amount"
                    ></td>
                    <td
                      v-if="isColumnSelected('action')"
                      class="border-x-0 sticky-amount"
                    ></td>
                  </tr>
                  <tr v-if="!filteredItems.length">
                    <td :colspan="headers.length" class="text-center">
                      {{ loading ? 'Loading...' : 'No data available' }}
                    </td>
                  </tr>
                </tbody>
              </VuePerfectScrollbar>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-dialog v-model="dialog" max-width="900px">
        <card-progress-tracking
          v-if="progressTracking"
          :loading="loadingDetail"
          :steps="steps"
        />
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { formatDate } from '@/utils/helpers';
import { toCurrencyWithoutSign } from '@/mixins/filter';
import CardProgressTracking from '@/components/SSHCP/CardProgressTracking';
import SelectColumnFilter from '@/components/SelectColumnFilter';
import FilterColumn from '@/components/filterColumn';
import DashboardFilter from '@/components/SSHCP/DashboardFilter';
import { exportToExcel } from '@/utils/helpers';
import moment from 'moment';
import PrevalNumber from '@/components/SSHCP/PrevalNumber';

export default {
  components: {
    VuePerfectScrollbar,
    CardProgressTracking,
    SelectColumnFilter,
    DashboardFilter,
    FilterColumn,
    PrevalNumber
  },
  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 340
    },
    columnActive: [],
    breadcrumbs: [
      {
        text: 'SSHCP',
        to: '/sshcp/'
      },
      {
        text: 'Request',
        to: '/sshcp/request/'
      }
    ],
    totalItems: 0,
    options: {
      itemsPerPage: 10,
      page: 1
    },
    loadingDetail: false,
    items: [],
    filter: null,
    loading: false,
    dialog: false,
    queryFilter: null,
    panelFilter: null,
    downloading: false
  }),
  watch: {
    panelFilter() {
      if (this.filterInfo.length > 0) {
        this.panelFilter = 0;
      } else {
        this.panelFilter = null;
      }
    },
    filterInfo() {
      if (this.filterInfo.length > 0) {
        this.panelFilter = 0;
      } else {
        this.panelFilter = null;
      }
    },
    filterRequest: {
      deep: true,
      handler(filter) {
        if (filter.isSubmit) {
          this.fetchData();
        }
      }
    }
  },
  computed: {
    ...mapState('sshcp', {
      progressTracking: 'progressTracking',
      filterRequest: 'filter'
    }),
    headers() {
      return [
        {
          text: 'SSHCP Code',
          align: 'left',
          value: 'unique_code',
          customClass: 'sticky-header1'
        },
        {
          text: 'PO Number',
          align: 'left',
          value: 'po_number',
          isCode: true
        },
        {
          text: 'IO Number',
          align: 'left',
          value: 'io_number',
          isCode: true
        },
        {
          text: 'House',
          align: 'left',
          value: 'house'
        },
        {
          text: 'Region',
          align: 'left',
          value: 'region'
        },
        {
          text: 'District',
          align: 'left',
          value: 'district'
        },
        {
          text: 'Type of Activity',
          align: 'left',
          value: 'type_of_activity'
        },
        {
          text: 'Event',
          align: 'left',
          value: 'events'
        },
        {
          text: 'Total Budget',
          align: 'left',
          value: 'total_budget',
          formatter: toCurrencyWithoutSign,
          columnType: true,
          exportFormat: val => +val
        },
        {
          text: 'Cost Per Pax',
          align: 'center',
          value: 'cost_per_pax',
          formatter: toCurrencyWithoutSign,
          columnType: true,
          exportFormat: val => +val
        },
        {
          text: 'Current Pending Approver',
          align: 'center',
          value: 'current_approval'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'local_status'
        },
        {
          text: 'Action',
          align: 'center',
          value: 'action'
        }
      ];
    },
    steps() {
      return this.progressTracking.map(item => {
        let itemApproved = item.find(val => val.approval_date !== null);
        return {
          group_name: item[0].group_name,
          email: item.map(val => val.email.toLowerCase()),
          name: item.map(val => {
            return {
              name: val.user_name,
              isApproved: !!val.approval_date
            };
          }),
          complete: itemApproved?.status === 'approved',
          date: itemApproved ? formatDate(itemApproved.approval_date) : '',
          status: itemApproved?.status,
          notes: itemApproved?.notes
        };
      });
    },
    filteredItems() {
      return this.getFilteredItems();
    },
    filterInfo() {
      let filter = this.filterRequest;
      let info = [];
      for (const property in filter) {
        if (property !== 'isSubmit' && filter[property]) {
          info.push({
            name: property,
            value: filter[property]
          });
        }
      }
      return info;
    }
  },
  created() {
    if (this.$route.query.typeFilter === 'house') {
      this.queryFilter = {
        type: this.$route.query.typeFilter,
        house_name: this.$route.query.house_name,
        house_id: this.$route.query.house_id
      };
    } else {
      this.queryFilter = {
        type: this.$route.query.typeFilter,
        name: this.$route.query.name
      };
    }
    // this.resetFilter();
  },
  async mounted() {
    this.panelFilter = 0;
    await this.selectAllColumn();
    this.fetchData();
  },
  methods: {
    resetFilter() {
      this.$store.commit('sshcp/set', {
        filter: {
          start_year: '',
          start_created_date: '',
          end_created_date: '',
          start_submitted_date: '',
          end_submitted_date: '',
          start_approved_date: '',
          end_approved_date: '',
          house: null,
          region: null,
          district: null,
          type_of_activity: null,
          status: null,
          isSubmit: true
        }
      });
      this.$router.push(this.$route.path);
      this.queryFilter = {};
    },
    async fetchData(params = {}) {
      this.loading = true;
      let status = null;
      if (this.filterRequest.status) {
        status = {
          field: 'local_status',
          data: this.filterRequest.status
        };
      }
      let start_year = '';
      if (this.filterRequest.start_year) {
        start_year = moment(this.filterRequest.start_year).format('YYYY');
      }
      let payload = {
        start_year: start_year || null,
        start_created_date: this.filterRequest.start_created_date || null,
        end_created_date: this.filterRequest.end_created_date || null,
        start_date_submitted: this.filterRequest.start_date_submitted || null,
        end_date_submitted: this.filterRequest.end_date_submitted || null,
        start_date_fully_approved:
          this.filterRequest.start_date_fully_approved || null,
        end_date_fully_approved:
          this.filterRequest.end_date_fully_approved || null,
        house_id: this.filterRequest.house?.id,
        region: this.filterRequest.region,
        district: this.filterRequest.district,
        filterArray: status,
        type_of_activity: this.filterRequest.type_of_activity || null
      };
      if (this.queryFilter) {
        if (this.queryFilter.type === 'house') {
          payload.house_id = this.queryFilter.house_id;
        } else {
          payload[this.queryFilter.type] = this.queryFilter.name;
        }
      }
      const res = await this.$store.dispatch('sshcp/getFormRequests', {
        ...payload,
        ...params,
        sort: 'desc',
        paginate: false,
        orderBy: 'id'
      });
      this.loading = false;
      this.items = res.data.listFormRequest.map(item => ({
        ...item,
        created_date: formatDate(item.created_date),
        events:
          item.events.length > 0
            ? item.events.map(val => val.name).join(', ')
            : '',
        current_approval:
          item.current_approval.length > 0
            ? item.current_approval.map(val => val.name).join(' / ')
            : '',
        pending_approval: item.current_approval,
        local_status: item.local_status?.split('_').join(' ')
      }));
      this.$store.commit('sshcp/set', {
        filter: {
          ...this.filterRequest,
          ...payload,
          status: this.filterRequest.status,
          filterArray: null,
          house_id: null,
          house:
            this.queryFilter.type === 'house'
              ? {
                  id: this.queryFilter.house_id,
                  name: this.queryFilter.house_name
                }
              : this.filterRequest.house,
          isSubmit: false
        }
      });
    },
    onRowClicked(item) {
      this.getDetail(item.id);
    },
    async getDetail(id) {
      this.dialog = true;
      this.loadingDetail = true;
      await this.$store.dispatch('sshcp/getProgressTracking', id);
      this.loadingDetail = false;
    },
    selectAllColumn() {
      this.columnActive = this.headers;
    },
    isHeaderSelected(header) {
      return this.columnActive.map(item => item.value).includes(header.value);
    },
    isColumnSelected(name) {
      return this.columnActive.filter(item => item.value === name).length > 0;
    },
    getNestedSort(obj) {
      this.nestedSort(obj.fieldName, this.items);
    },
    getFilteredItems() {
      const obj = this.filter;
      let arr = this.items;

      if (!obj) return arr;

      let nameField = obj.fieldName;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      let result = [];
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        result = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(String(a[nameField]));
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 4) {
          result = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else {
          result = this.items;
        }
      }

      return result;
    },
    getFiltered(name) {
      if (!name.includes('.')) {
        return Object.keys(
          this.items.reduce((result, arr) => {
            result[arr[name]] = [...(result[arr[name]] || []), arr];
            return result;
          }, {})
        );
      } else {
        let nameField = name.split('.');
        return Object.keys(
          this.items.reduce((result, arr) => {
            if (!arr[nameField[0]]) return;
            result[arr[nameField[0]][nameField[1]]] = [
              ...(result[arr[nameField[0]][nameField[1]]] || []),
              arr
            ];
            return result;
          }, {})
        );
      }
    },
    searchCln(obj) {
      this.filter = obj;
    },
    totalAmountFor(key) {
      return this.filteredItems
        .reduce((total, val) => {
          const value = +(val[key] || 0);
          total += value;
          return total;
        }, 0)
        .toLocaleString('id');
    },
    async download() {
      this.downloading = true;
      const headers = this.columnActive.filter(item => item.value !== 'action');
      const columns = headers.map(item => item.text);
      const items = this.filteredItems.map(item =>
        headers.map(header =>
          header.formatter
            ? header.formatter(item[header.value])
            : item[header.value]
        )
      );
      const date = moment().format('YYYY-MM-DD-HHmmss');
      const fileName = `Request-Reports-${date}`;

      await exportToExcel(columns, items, fileName);

      this.downloading = false;
    }
  }
};
</script>

<style lang="scss">
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
.hoverable-tr {
  cursor: pointer;

  &:hover {
    background: #dfdfdf;
  }
}

.drawer-menu--scroll {
  max-height: 600px;
  overflow: auto;
}
</style>
